import {configuracionService} from "@/api/coreApi";

const state = {
  loading: true,
  module: null,
  partidoId: null,
  error: null
};

const actions = {
  getRoles({commit}) {
    return new Promise((resolve, reject) => {
      commit('rolesInit')

      configuracionService.getRoles()
        .then(response => {
          if (response.data.statusCode === 200) {
            commit('rolesSuccess', response.data)
            resolve()
          } else {
            commit('rolesFailure', response)
            reject()
          }
        })
        .catch(error => {
          commit('rolesFailure', error)
          reject()
        });

    })

  },
};

const mutations = {
  rolesInit(mstate) {
    mstate.loading = true
  },
  rolesSuccess(mstate, data) {
    mstate.loading = false
    const json = JSON.parse(data.datos)
    mstate.module = json.roles
    mstate.partidoId = json.partidoId
  },
  rolesFailure(mstate, error) {
    mstate.error = error
  }
};

export const roles = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};
